'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _commonFormsy = require('../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FlagContactModal = (_dec = (0, _mobxReact.inject)('UiStore', 'OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(FlagContactModal, _Component);

  function FlagContactModal(props) {
    _classCallCheck(this, FlagContactModal);

    var _this = _possibleConstructorReturn(this, (FlagContactModal.__proto__ || Object.getPrototypeOf(FlagContactModal)).call(this, props));

    _initDefineProp(_this, 'value', _descriptor, _this);

    _this.onClose = props.UiStore.modals.FlagContact.close;
    return _this;
  }

  _createClass(FlagContactModal, [{
    key: 'handleRadioClick',
    value: function handleRadioClick(e) {
      this.value = e.target.value;
    }
  }, {
    key: 'onValidSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, contact, submitWarning, funderId, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, contact = _props.contact, submitWarning = _props.submitWarning, funderId = _props.funderId, data = {
                  owner: funderId,
                  party: contact.id,
                  reason: this.value
                };


                submitWarning(data);
                this.onClose();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onValidSubmit() {
        return _ref.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this2 = this;

      var warningReasons = this.props.OptionsStore.warningReasons,
          warningKeys = Object.keys(warningReasons).sort();

      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true },
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'radio-group' },
              _react2.default.createElement(
                'ul',
                { className: 'radio-buttons' },
                warningKeys.map(function (key) {
                  return _react2.default.createElement(
                    'li',
                    { key: key },
                    _react2.default.createElement('input', {
                      type: 'radio',
                      id: key,
                      checked: key === _this2.value,
                      value: key,
                      onChange: _this2.handleRadioClick
                    }),
                    _react2.default.createElement(
                      'label',
                      { htmlFor: key },
                      warningReasons[key]
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: this.onClose },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            onValidSubmit: this.onValidSubmit
          },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              'What\'s the reason for flagging this contact?'
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              _react2.default.createElement(
                _Button2.default,
                { onClick: this.onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: !this.value, bsStyle: 'primary', type: 'submit' },
                'Save'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FlagContactModal;
}(_react.Component), _class3.propTypes = {
  funderId: _propTypes2.default.string.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  submitWarning: _propTypes2.default.func.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onValidSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onValidSubmit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = FlagContactModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FlagContactModal, 'FlagContactModal', '/app/src/components/page-contacts/FlagContactModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-contacts/FlagContactModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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